import Swal from 'sweetalert2';

import { parseJwt } from '../../../modules/common';
import { IDefaultValue } from '../../../models/DefaultValue';

function useCreateDefaultValue() {
    const createDefaultValue = async (defaultValue: IDefaultValue) => {
        const jwt = parseJwt(String(localStorage.getItem('DMS_APPLICATION')));
        const extra = JSON.parse(jwt.extra);

        const data: IDefaultValue = {
            sid: defaultValue.sid,
            key: defaultValue.key,
            contain_key: defaultValue.contain_key,
            value: defaultValue.value,
            created_by: extra.citizen_id,
        };

        try {
            const response = await fetch('/v1/default-value', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('DMS_APPLICATION')}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                return true;
            } else {
                throw await response.json();
            }
        } catch (error) {
            const { message } = error as any;
            console.error(message);
            Swal.fire({
                title: 'เกิดข้อผิดพลาด',
                text: message,
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ยืนยัน',
            });
            return;
        }
    };

    return {
        createDefaultValue,
    };
}

export default useCreateDefaultValue;
